/* Ballon King cart: Bestellschluss-Countdown, one-tap add-ons, sticky checkout on /cart. */
(function () {
  var DAY = 864e5;
  var MONTHS = { januar: 0, februar: 1, 'märz': 2, maerz: 2, april: 3, mai: 4, juni: 5, juli: 6, august: 7, september: 8, oktober: 9, november: 10, dezember: 11 };
  var WDL = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  // Buunto cut-offs (same as homepage bk-v3.js, 03.10.2026): delivery = day before 16:00 (Monday: Friday 16:00),
  // pickup = same day 16:00 (Saturday 12:00)
  var CUT = { delivery: { def: [16, 1], 1: [16, 3] }, pickup: { def: [16, 0], 6: [12, 0] } };
  // Delivery closed days (Buunto, same list as bk-v3.js)
  var OFF = ['2026-12-25', '2026-12-26', '2026-12-28', '2027-01-01', '2027-01-02', '2027-01-04', '2027-03-26', '2027-03-29', '2027-05-01', '2027-05-17'];
  function closed(ms) { return OFF.indexOf(new Date(ms).toISOString().slice(0, 10)) >= 0; }

  // Zurich wall clock as fake-UTC milliseconds
  function zurichNow() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Zurich', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    } catch (e) {
      var d = new Date();
      return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
    }
  }
  function wd(ms) { return new Date(ms).getUTCDay(); }
  function parseDate(s) {
    var m = String(s || '').trim().toLowerCase().match(/^(\d{1,2})\.\s*([a-zäöü]+)\s+(\d{4})$/);
    if (!m || MONTHS[m[2]] === undefined) return 0;
    return Date.UTC(+m[3], MONTHS[m[2]], +m[1]);
  }
  function left(ms) {
    var mins = Math.max(1, Math.ceil(ms / 6e4)), h = Math.floor(mins / 60), m = mins % 60;
    return h >= 1 ? h + ' Std. ' + m + ' Min.' : m + ' Min.';
  }

  // only touch the DOM on change (the MutationObserver below would loop otherwise)
  function setText(el, txt) { if (el.textContent !== txt) el.textContent = txt; }

  function updateCutoffs() {
    var now = zurichNow(), today = now - (now % DAY);
    document.querySelectorAll('[data-bkc-cut]').forEach(function (el) {
      var day = parseDate(el.getAttribute('data-bkc-date'));
      var rule = CUT[el.getAttribute('data-bkc-method') === 'pickup' ? 'pickup' : 'delivery'];
      if (!day) { el.hidden = true; return; }
      var c = rule[wd(day)] || rule.def, deadline = day - c[1] * DAY + c[0] * 36e5, rest = deadline - now;
      var box = el.parentNode && el.parentNode.querySelector('[data-bkc-promise-text]');
      if (rest <= 0) {
        // Order deadline for the chosen date has passed (cart kept from an earlier visit)
        if (box) setText(box, 'Kein Stress: Für dieses Datum ist Bestellschluss vorbei. Entfern den Artikel und wähl ein neues Datum.');
        el.hidden = true;
        return;
      }
      if (rest <= 24 * 36e5) {
        var when = deadline - (deadline % DAY) === today ? 'heute' : 'morgen';
        setText(el, 'Bestell bis ' + when + ' ' + c[0] + '.00 Uhr, dann klappt es (noch ' + left(rest) + ')');
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    // No date in cart: next working day promise (Mo-Fr 16:00)
    document.querySelectorAll('[data-bkc-next]').forEach(function (el) {
      var t = el.querySelector('[data-bkc-next-text]'), cutDay = 0, delDay = 0;
      for (var k = 0; k < 8; k++) {
        var d = today + k * DAY, w = wd(d);
        if (w >= 1 && w <= 5 && d + 16 * 36e5 > now) { cutDay = d; delDay = d + (w === 5 ? 3 : 1) * DAY; break; }
      }
      while (delDay && (closed(delDay) || wd(delDay) === 0 || wd(delDay) === 6)) delDay += DAY;
      if (!cutDay || !t) { el.hidden = true; return; }
      var cutTxt = cutDay === today ? 'Bis 16.00 Uhr bestellt' : (cutDay === today + DAY ? 'Bis morgen 16.00 Uhr bestellt' : 'Bis ' + WDL[wd(cutDay)] + ' 16.00 Uhr bestellt');
      var delTxt = delDay === today + DAY ? 'morgen da' : (delDay - today <= 6 * DAY ? 'am ' + WDL[wd(delDay)] + ' da' : 'am ' + new Date(delDay).getUTCDate() + '.' + (new Date(delDay).getUTCMonth() + 1) + '. da');
      setText(t, cutTxt + ', ' + delTxt);
      el.hidden = false;
    });
  }

  // Grusskarten row in the drawer: "+ Dazu" opens a popup (native <dialog>, top layer above drawer and header).
  // The whole flow lives in the popup: write text -> "Karte dazulegen" -> confirmation -> closes.
  // The text goes on the card line as property "Grusskarte" (same name as the PDP field, the team knows it).
  var MAX = 200, dlg = null, dlgBtn = null;
  function buildDialog() {
    dlg = document.createElement('dialog');
    dlg.className = 'bkd';
    dlg.setAttribute('aria-labelledby', 'bkd-title');
    dlg.innerHTML =
      '<div class="bkd-in">' +
        '<button type="button" class="bkd-x" data-bkd-close aria-label="Schliessen"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="bkd-step" data-bkd-step="write">' +
          '<div class="bkd-card"><img alt="" data-bkd-img><div><b data-bkd-name></b><span data-bkd-price></span></div></div>' +
          '<h2 class="bkd-title" id="bkd-title">Was soll auf der Karte stehen?</h2>' +
          '<p class="bkd-sub">Die Karte kommt mit deinem Text zu deiner Bestellung.</p>' +
          '<label class="bkd-label" for="bkd-text">Dein Text</label>' +
          '<textarea class="bkd-text" id="bkd-text" rows="4" maxlength="' + MAX + '" placeholder="z. B. Happy Birthday! Lass dich feiern." data-bkd-text></textarea>' +
          '<div class="bkd-meta"><span data-bkd-count aria-live="polite">0/' + MAX + ' Zeichen</span><span class="bkd-err" data-bkd-err role="alert" hidden></span></div>' +
          '<button type="button" class="bkd-add" data-bkd-add disabled>Karte dazulegen</button>' +
          '<button type="button" class="bkd-cancel" data-bkd-close>Abbrechen</button>' +
        '</div>' +
        '<div class="bkd-step bkd-done" data-bkd-step="done" hidden>' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M7.5 12.5l3 3 6-6.5"/></svg>' +
          '<p class="bkd-title" tabindex="-1" data-bkd-done>Passt! Die Karte liegt im Warenkorb.</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);
    // Esc closes only the popup: the drawer (theme.js ccPopup) closes on every window keydown 27 otherwise.
    // stopPropagation keeps the native dialog cancel (default action) working.
    dlg.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) e.stopPropagation(); });
    // click on the dark backdrop closes, but not when a text selection started inside the popup
    var downOnBackdrop = false;
    dlg.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === dlg; });
    dlg.addEventListener('click', function (e) { if (e.target === dlg && downOnBackdrop) dlg.close(); downOnBackdrop = false; });
    dlg.addEventListener('close', function () {
      // after saving, the drawer re-renders and the "+ Dazu" button is gone: focus the drawer's cart form instead
      var back = dlgBtn && document.contains(dlgBtn) ? dlgBtn : document.querySelector('.cart-drawer .cart-item__title, .cart-drawer a, .cart-drawer button');
      if (back) back.focus();
    });
  }
  function q(sel) { return dlg.querySelector(sel); }
  function openDialog(btn) {
    if (!window.HTMLDialogElement) return false;
    if (!dlg) buildDialog();
    dlgBtn = btn;
    dlg.setAttribute('data-variant', btn.getAttribute('data-bku-add'));
    q('[data-bkd-name]').textContent = btn.getAttribute('data-bku-name') || '';
    q('[data-bkd-price]').textContent = btn.getAttribute('data-bku-price') || '';
    var img = q('[data-bkd-img]'), src = btn.getAttribute('data-bku-img');
    img.hidden = !src;
    if (src) img.src = src;
    var t = q('[data-bkd-text]');
    t.value = '';
    q('[data-bkd-count]').textContent = '0/' + MAX + ' Zeichen';
    q('[data-bkd-err]').hidden = true;
    q('[data-bkd-add]').disabled = true;
    q('[data-bkd-step="write"]').hidden = false;
    q('[data-bkd-step="done"]').hidden = true;
    dlg.showModal();
    t.focus();
    return true;
  }
  function addCard() {
    var text = q('[data-bkd-text]').value.trim(), add = q('[data-bkd-add]'), err = q('[data-bkd-err]');
    if (!text) return;
    add.setAttribute('aria-busy', 'true');
    err.hidden = true;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +dlg.getAttribute('data-variant'), quantity: 1, properties: { Grusskarte: text } }] })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      q('[data-bkd-step="write"]').hidden = true;
      q('[data-bkd-step="done"]').hidden = false;
      q('[data-bkd-done]').focus();
      document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
      setTimeout(function () { if (dlg.open) dlg.close(); }, 1400);
    }).catch(function () {
      err.textContent = 'Kein Stress, das hat nicht geklappt. Versuch es nochmal.';
      err.hidden = false;
    }).finally(function () { add.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-bku-add]');
    if (btn) {
      e.preventDefault();
      // old browsers without <dialog>: go to the product page, the text field is there
      if (!openDialog(btn)) window.location.href = btn.closest('.bku-card').querySelector('.bku-name').href;
      return;
    }
    if (!dlg || !dlg.contains(e.target)) return;
    if (e.target.closest('[data-bkd-close]')) { e.preventDefault(); dlg.close(); return; }
    if (e.target.closest('[data-bkd-add]')) { e.preventDefault(); addCard(); }
  });
  document.addEventListener('input', function (e) {
    if (!dlg || !e.target.matches || !e.target.matches('[data-bkd-text]')) return;
    q('[data-bkd-count]').textContent = e.target.value.length + '/' + MAX + ' Zeichen';
    q('[data-bkd-add]').disabled = !e.target.value.trim();
  });

  // /cart (phone): sticky checkout bar hides while the real button is on screen
  var io = null, watched = null, watchedBar = null;
  function watchSticky() {
    var bar = document.querySelector('[data-bkc-sticky]'), main = document.getElementById('update-cart');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    if (main === watched && bar === watchedBar) return;
    if (io) io.disconnect();
    watched = main; watchedBar = bar;
    io = new IntersectionObserver(function (en) { bar.classList.toggle('is-off', en[0].isIntersecting); });
    io.observe(main);
  }

  function refresh() { updateCutoffs(); watchSticky(); }
  var queued = false;
  new MutationObserver(function () {
    if (queued || !document.querySelector('[data-bkc-cut],[data-bkc-next],[data-bkc-sticky]')) return;
    queued = true;
    setTimeout(function () { queued = false; refresh(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  setInterval(updateCutoffs, 30000);
})();
